////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { map } from 'lodash'

/////////STYLED/////////
const RadioContainerWrapper = styled.div``
const RadioTitle = styled.p`
	color: ${(props) => props.theme.colors.tabText};
	font-weight: bold;
`
const RadioInputPerimeter = styled.input``
const RadioInputLabel = styled.label`
	display: grid;
	align-items: center;
	grid-template-columns: repeat(2, minmax(min-content, max-content));
	grid-column-gap: 10px;
`
/////////STYLED/////////

/**
 *
 * @param Title
 * @param list
 * @param register
 * @return {*}
 * @constructor
 */
const RadioContainer = ({ register, title, name, list, handleSubmit }) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<RadioContainerWrapper>
			<RadioTitle>{title}</RadioTitle>
			{map(list, (elem, id) => {
				return (
					<RadioInputLabel key={id}>
						<RadioInputPerimeter
							type="radio"
							value={elem.id.toString()}
							name={name}
							ref={register}
							onClick={() => {
								handleSubmit()
							}}
						/>
						 {elem.label}
					</RadioInputLabel>
				)
			})}
		</RadioContainerWrapper>
	)
}

RadioContainer.propTypes = {}

RadioContainer.defaultPropTypes = {}

export default RadioContainer
